import React from 'react';
import PropTypes from 'prop-types';
import { join } from 'lodash';
import { Field } from 'formik';
import {
  DateField,
  GridContainer,
  GridItem,
  TextFieldWrapper,
} from '../../common';

const SURGERY_TYPE = 'type';
const SURGERY_DATE = 'date';
const SURGERY_NOTES = 'notes';
const HOSPITAL = 'hospital';

function Surgery({ paths, setFieldValue, values }) {
  return (
    <GridContainer>
      <GridItem lg={4} xs={12}>
        <Field
          component={TextFieldWrapper}
          id={SURGERY_TYPE}
          label="Type of Surgery"
          name={join([...paths, SURGERY_TYPE], '.')}
          paths={[...paths, SURGERY_TYPE]}
        />
      </GridItem>
      <GridItem lg={4} xs={12}>
        <Field
          component={TextFieldWrapper}
          id={HOSPITAL}
          label="Hospital"
          name={join([...paths, HOSPITAL], '.')}
          paths={[...paths, HOSPITAL]}
        />
      </GridItem>
      <GridItem lg={4} xs={12}>
        <DateField
          fieldName={SURGERY_DATE}
          label="Date"
          paths={paths}
          setFieldValue={setFieldValue}
          values={values}
        />
      </GridItem>
      <GridItem lg={12} xs={12}>
        <Field
          component={TextFieldWrapper}
          id={SURGERY_NOTES}
          label="Notes"
          multiline
          name={join([...paths, SURGERY_NOTES], '.')}
          paths={[...paths, SURGERY_NOTES]}
        />
      </GridItem>
    </GridContainer>
  );
}

Surgery.propTypes = {
  setFieldValue: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  paths: PropTypes.array,
};

Surgery.defaultProps = {
  paths: [],
};

export default Surgery;



// WEBPACK FOOTER //
// ./src/modules/SurgeryPage/components/Surgery.js